import runApp from './run';

runApp();
